// Import model
import { FilterMaterialAssignmentRequest } from '../models/FilterMaterialAssignmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { MaterialAssignmentCondition } from '../models/MaterialAssignmentCondition';
import { MaterialAssignmentFields } from '../models/MaterialAssignmentFields';
import { MaterialAssignmentIndexedFields } from '../models/MaterialAssignmentIndexedFields';

// Import dependency serializers (for complex types)
import { MaterialAssignmentConditionSerializer } from './MaterialAssignmentConditionSerializer';
import { MaterialAssignmentFieldsSerializer } from './MaterialAssignmentFieldsSerializer';
import { MaterialAssignmentIndexedFieldsSerializer } from './MaterialAssignmentIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterMaterialAssignmentRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterMaterialAssignmentRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterMaterialAssignmentRequest instance
   */
  static deserialize(json: string): FilterMaterialAssignmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterMaterialAssignmentRequest instance
   */
  static fromObject(obj: any): FilterMaterialAssignmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterMaterialAssignmentRequest');
    }


    const instance: FilterMaterialAssignmentRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as MaterialAssignmentIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as MaterialAssignmentFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        MaterialAssignmentConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterMaterialAssignmentRequest instances
   */
  static deserializeArray(json: string): FilterMaterialAssignmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterMaterialAssignmentRequest instance to a JSON string
   */
  static serialize(instance: FilterMaterialAssignmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterMaterialAssignmentRequest instance to a plain object
   */
  static toObject(instance: FilterMaterialAssignmentRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        MaterialAssignmentConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterMaterialAssignmentRequest instances to a JSON string
   */
  static serializeArray(instances: FilterMaterialAssignmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
